import { takeEvery, call, put } from "redux-saga/effects";
import {
  REGION_EMAIL_DELETE_REQUEST,
  regionEmailDeleted,
  regionEmailDeleteError,
} from "../../actions/regions";
import deleteEmail from "../../../../../backend/oncall/partners/regions/emails/remove";

const requestDeleteEmail = function*(action) {
  try {
    yield call(deleteEmail, action.payload.regionId, action.payload.email);
    yield put(regionEmailDeleted(action.payload.email));
  } catch (ignore) {
    yield put(regionEmailDeleteError(action.payload.email));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeEvery(REGION_EMAIL_DELETE_REQUEST, requestDeleteEmail);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/regions/request-delete-email.js